import { size } from 'underscore';

export const getValidationErrorMsg = ({
  i18n,
  selected,
  existingCount,
  hasRemoveExistingImages,
  maxCount,
}) => {
  const selectionCount = size(selected);

  if (selectionCount === 0 && !hasRemoveExistingImages) {
    return i18n.getString(_TL_('Please select a photo to upload or remove an existing one.'));
  }

  const currentCount = selectionCount + existingCount;
  if (currentCount > maxCount) {
    return i18n.getString(_TL_('You\'ve selected the max number of photos allowed in your gallery ({{max}}). Please remove {{count}} photo(s).'), {
      max: maxCount,
      count: currentCount - maxCount,
    });
  }

  return null;
};
